import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

const nameMap: Record<string, string> = {
  '': '首页',
  'about': '关于我们',
  'category': '漫画分类',
};

export default function Breadcrumb() {
  const location = useLocation();
  const pathParts = location.pathname.split('/').filter(Boolean);

  if (pathParts.length === 0) return null;

  const breadcrumbs = [{ label: '首页', path: '/' }];

  pathParts.forEach((part, index) => {
    const path = '/' + pathParts.slice(0, index + 1).join('/');
    let label = '';

    if (part === 'category' && pathParts[index + 1]) {
      const cat = categories.find((c) => c.slug === pathParts[index + 1]);
      if (cat) return;
    }

    if (part === 'comic') {
      label = '漫画详情';
    } else if (part === 'about') {
      label = nameMap['about'];
    } else if (part === 'category') {
      const nextPart = pathParts[index + 1];
      const cat = categories.find((c) => c.slug === nextPart);
      label = cat ? cat.name : '分类';
    } else if (categories.find((c) => c.slug === part)) {
      label = categories.find((c) => c.slug === part)?.name || part;
    } else {
      label = nameMap[part] || part;
    }

    breadcrumbs.push({ label, path });
  });

  return (
    <nav aria-label="面包屑导航" className="max-w-[1400px] mx-auto px-4 md:px-6 py-3">
      <ol className="flex items-center gap-2 text-sm text-foreground-500 flex-wrap">
        {breadcrumbs.map((crumb, index) => (
          <li key={crumb.path} className="flex items-center gap-2">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            )}
            {index === breadcrumbs.length - 1 ? (
              <span className="text-foreground-700 font-medium">{crumb.label}</span>
            ) : (
              <Link to={crumb.path} className="hover:text-primary-600 transition-colors duration-200 cursor-pointer">
                {crumb.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}